import { useAuth } from '@/features/auth/hooks/useAuth';
import type { PermissaoChave } from '@/shared/permissoes/chaves';
import { hasAnyPermission, hasPermission } from '@/shared/permissoes/hasPermission';

export interface Permissoes {
  /** Chaves concedidas pelo servidor. `undefined` enquanto o `/me` carrega. */
  concedidas: readonly string[] | undefined;
  carregando: boolean;
  pode: (chave: PermissaoChave) => boolean;
  podeAlguma: (chaves: readonly PermissaoChave[]) => boolean;
}

/**
 * Lê as permissões da sessão.
 *
 * ⚠️ **Permissão no cliente é UX, não segurança.** Esconder um botão é
 * conveniência; a defesa é o 403 do servidor. Este hook nunca infere nada —
 * repassa `hasPermission`, que é fail-closed, sem wildcard e sem prefixo.
 */
export function usePermissoes(): Permissoes {
  const { me, carregando } = useAuth();
  const concedidas = me?.permissoes;

  return {
    concedidas,
    carregando,
    pode: (chave) => hasPermission(concedidas, chave),
    podeAlguma: (chaves) => hasAnyPermission(concedidas, chaves),
  };
}
